import React from 'react'

export const useToggle = (initialState = false): [boolean, () => void] => {
  const [state, setState] = React.useState<boolean>(initialState)
  const toggle = React.useCallback(() => setState(state => !state), [])
  return [state, toggle]
}
